import React from "react";
import { Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import productOne from "../../assets/img/vin.jpg";
import productTwo from "../../assets/img/about/jj2.jpg";
import productThree from "../../assets/img/jj1.jpg";
import productFour from "../../assets/img/spicesProduct.webp";
import productFive from "../../assets/img/jewellary.png";

const titleStyles = {
  fontSize: ".9em",
 
};

export default function ProductLayout() {
  const productData = [
    {
      path: "/herbalProduct",
      img: productOne,
      title: "statue",
    },
    {
      path: "/gardenProduct",
      img: productTwo,
      title: "Jewellery",
    },

    // {
    //   path: "/spices",
    //   img: productFour,
    //   title: "Spices",
    // },
    {
      path: "/yogaProduct",
      img: productFive,
      title: "Thanjavur Art",
    },
    {
      path: "/foodProduct",
      img: productThree,
      title: "Others",
    },
  ];

  return (
    <>
      {productData.map((data, index) => {
        return (
          <Col
            xs={12}
            sm={6}
            md={4}
            lg={3}
            xl={3}
            className="mb-4"
            key={index + "product"}
          >
            <div className="card h-80 d-flex flex-column">
              <Link to={data.path} className="d-block">
                <img
                  src={data.img}
                  className="card-img-top"
                  alt="chakara art and craft products"
                  style={{
                    height: "300px",
                    width: "100%",
                    // objectFit: "cover",
                    borderTopLeftRadius: "8px",
                    borderTopRightRadius: "8px",
                  }}
                />
              </Link>
              <div
                className="card-body d-flex justify-content-center align-items-center"
                style={{ boxShadow: "1px 1px 20px rgba(183, 180, 180, 0.5)" }}
              >
                <Link
                  to={data.path}
                  className="h6 text-decoration-none text-uppercase text-dark text-center productTitle"
                  style={titleStyles}
                >
                  {data.title}
                </Link>
              </div>
            </div>
          </Col>
        );
      })}
    </>
  );
}